import { Component } from '@angular/core';

import '../../prism/prism.js';
import { LanguageSettings } from '../../providers/languageSettings.service';

declare var Prism;

@Component({
  selector: 'app-example-qr-module',
  templateUrl: './example-qr-module.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css']
})

/**
 * Class holding the example snippets for Cardless features.
 */
export class ExampleQrComponent {
/**
 * initialize content
 */

JavaInitializePrism:string;
JavaInitialize:string = "\
try {\n\
    InputStream is = null;\n\
    BitmapFactory.Options options = new BitmapFactory.Options();\n\
    options.inSampleSize = 4000;\n\
    \n\
    AssetManager assets = getActivity().getAssets();\n\
    AssetFileDescriptor descriptor = assets.openFd(\"icon.png\");\n\
    is = descriptor.createInputStream();\n\
    SGConnectQR.initialize(new SGConfiguration(\n\
            \"https://CardlessCoordinatorUrlExample.com\"\n\
            ),\n\
    is);\n\
    \n\
} catch (Exception e) {\n\
    e.printStackTrace();\n\
}";

SwiftInitializePrism: string;
SwiftInitialize = '\
let assetPath = Bundle.main.path(forResource: "imageName", ofType: "png")\n\
\n\
SGConnectQR.initialize(\n\
  withConfiguration: SGConfiguration.init(withURL: url),\n\
   andBrandLogoImageAtPath: assetPath\n\
   )\n\
';



JavaScriptInitializePrism:string;
JavaScriptInitialize:string = "\
onDeviceReady: function() {\n\
  SGConnectAPIPlugin.addObserver(\"SGBLEConnectionState\", function(state){  \n\
    //\"state\" is a string representing the connection state as declared in the enum \n\
  }, function(error){ \n\
    //\"error\" is a json string and with keys = type, localizedDescription & debugInformation, values are strings \n\
  }); \n\
";

/**
 * QR STATUS CALLBACK CONTENT
 */

JavaSGQRStatusCallBackPrism:string;
JavaSGQRStatusCallBack:string ="\
SGConnectQR.addObserver(new SGQRObserver() {\n\
  @Override\n\
  public void update(Enum status) {\n\
      Log.w(TAG, \"status-----\" + status);\n\
      if (status == ENDING) {\n\
        \n\
      } else if (status == ENDED) {\n\
          setOfflineState();\n\
      }\n\
  }\n\
  \n\
  @Override\n\
  public void onError(SGError err) {\n\
      Log.w(TAG, \"SGError-----\" + err.getErrorType());\n\
      ((BaseActivity) getActivity()).showSnack(err.getErrorType(), rootView);\n\
  }\n\
}, this.getClass().getName());\n\
";

SwiftSGQRStatusCallBackPrism: string;
SwiftSGQRStatusCallBack = '\
SGConnectQR.addObserver { (state: SGQRConnectionState, error) in\n\
  if state == .error {\n\
      print(print("\(self.TAG) - \(error!.type) - \(error!.localizedDescription)"))\n\
  }\n\
  else {\n\
      print("\(self.TAG) - \(state)")\n\
  }\n\
}';

  JavaScriptSGQRStatusCallBackPrism:string;
  JavaScriptSGQRStatusCallBack:string = "\
onDeviceReady: function() {\n\
  SGConnectAPIPlugin.addObserver('SGDeviceProximityState', function(state){  \n\
    //'state' is a string representing the proximity state as declared in the enum \n\
  }, function(error){ \n\
    //'error' is a json string and with keys = type, localizedDescription & debugInformation, values are strings \n\
  }); \n\
}";



/**
 * SG CONNECT DISCONNECT CONTENT
 */
JavaConnectPrism: string;
JavaConnect = '\
SGConnectQR.createSession(YourActivity.this,\n\
  Constants.SGQRSessionCreationOptions.AccountNumber,\n\
  accountNumberString\n\
);\n\
';

SwiftConnectPrism: string;
SwiftConnect = '\
SGConnectQR.createSession(withSessionCreationOption: creationOptions.accountNumber,\n\
  withValue: accountNumber\n\
)\n\
';

JavaScriptConnectPrism: string;
JavaScriptConnect = '\n"); //using example card number';

  constructor(public languageSettings: LanguageSettings) {
    this.applyPrism();
  }

  applyPrism() {
    this.JavaInitializePrism = Prism.highlight(this.JavaInitialize, Prism.languages.java);
    this.JavaConnectPrism = Prism.highlight(this.JavaConnect, Prism.languages.java);
    this.JavaSGQRStatusCallBackPrism = Prism.highlight(this.JavaSGQRStatusCallBack, Prism.languages.java);

    this.SwiftInitializePrism = Prism.highlight(this.SwiftInitialize, Prism.languages.swift);
    this.SwiftConnectPrism = Prism.highlight(this.SwiftConnect, Prism.languages.swift);
    this.SwiftSGQRStatusCallBackPrism = Prism.highlight(this.SwiftSGQRStatusCallBack, Prism.languages.swift);


    this.JavaScriptSGQRStatusCallBackPrism = Prism.highlight(this.JavaScriptSGQRStatusCallBack, Prism.languages.javascript);
    this.JavaScriptConnectPrism = Prism.highlight(this.JavaScriptConnect, Prism.languages.javascript);
  }

}
